<div class="export-window">

    <div class="window-title">
        <div>
            <i class="bi bi-bar-chart-line-fill title-icon"></i>
            Exportar Datos
        </div>
    </div>

    <div class="export-content">

        <h2>Exportar Datos</h2>
        <p class="subtitle">Seleccione la información que desea exportar.</p>

        <div class="form-row">
            <label>Información</label>

            <select class="modern-select" [ngModel]="transaccionSeleccionada()"
                (ngModelChange)="cambiarTransaccion($event)" [disabled]="cargandoTransacciones()">

                <option [ngValue]="null" disabled>
                    {{ cargandoTransacciones() ? 'Cargando...' : 'Seleccione...' }}
                </option>

                <option *ngFor="let item of transacciones()" [ngValue]="item">
                    {{ item.descripcion || item.Descripcion }}
                </option>
            </select>
        </div>

        <div class="description" *ngIf="descripcionLarga()">
            {{ descripcionLarga() }}
        </div>

        <div class="date-row" *ngIf="mostrarFechas()">
            <div class="field-group">
                <label>Fecha Inicial</label>
                <input type="date" [ngModel]="fechaInicial() ?? ''" (ngModelChange)="actualizarFechaInicial($event)">
            </div>

            <div class="field-group">
                <label>Fecha Final</label>
                <input type="date" [ngModel]="fechaFinal() ?? ''" (ngModelChange)="actualizarFechaFinal($event)">
            </div>
        </div>

        <div class="date-row" *ngIf="mostrarCodigos()">
            <div class="field-group">
                <label>{{ tituloCodigos() }} Inicial</label>
                <input type="text" [ngModel]="codigoInicial()" (ngModelChange)="codigoInicial.set($event)">
            </div>

            <div class="field-group">
                <label>{{ tituloCodigos() }} Final</label>
                <input type="text" [ngModel]="codigoFinal()" (ngModelChange)="codigoFinal.set($event)">
            </div>
        </div>

        <div class="form-row">
            <label>Archivo</label>
            <input class="file-input" type="text" [ngModel]="nombreArchivo()"
                (ngModelChange)="nombreArchivo.set($event)">
        </div>
        <div class="generating-message" *ngIf="generandoArchivo()">
            <div class="spinner-border spinner-border-sm me-2" role="status">
                <span class="visually-hidden">Generando...</span>
            </div>

            Generando archivo, por favor espere...
        </div>

        <div class="actions">
            <button type="button" class="icon-button clear-button  text-white" (click)="limpiar()"
                title="Limpiar campos">
                Limpiar
            </button>

            <button type="button" class="btn btn-info  text-white" (click)="procesar()"
                title="Procesar y exportar datos">
                Procesar
            </button>

            <button type="button" class="btn btn-danger  text-white " title="Salir de la pantalla" (click)="salir()">
                Salir
            </button>
        </div>

    </div>

</div>